import React from 'react'
import { Router, RouteComponentProps } from '@reach/router'
import Appbar from 'components/Appbar'
import TableView from './TableView'
import useProjections from './hooks/useProjections'
import { IconButton, ModalLayer, PageContent } from '@ui'
import { Tooltip2 } from '@blueprintjs/popover2'

export default function ProjectionManagement({ navigate }: RouteComponentProps) {
  const projections = useProjections()

  return (
    <>
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigate}>
        <ModalLayer path="*" />
      </Router>

      <Appbar
        title={
          <span>
            {projections.detail && (
              <span style={{ marginRight: 8 }}>
                <Tooltip2 content="Back to Import History">
                  <IconButton
                    onClick={() => projections.selectDetail(null)}
                    iconName="chevron-left"
                    minimal
                  />
                </Tooltip2>
              </span>
            )}
            Projections
          </span>
        }
      ></Appbar>
      <PageContent>
        <TableView
          {...{
            projections,
            navigate,
          }}
        />
      </PageContent>
    </>
  )
}
